import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./progressGate.module.scss";

interface ProgressGateProps {
    children: ReactNode;
    message?: string;
}

// Wraps a progress display (a counter, a percentage, a practice-history
// message) that should only be shown once there's an account to save it to -
// otherwise a signed-out visitor's numbers look identical to a signed-in
// user's saved progress, which is misleading about whether anything is
// actually being kept long-term.
function ProgressGate({ children, message = "Log in to track your progress" }: ProgressGateProps) {
    const { status } = useAuth();
    const location = useLocation();

    if (status === "authenticated") return <>{children}</>;

    return (
        <p className={styles.prompt}>
            <Link to="/login" state={{ from: location }}>{message}</Link>
        </p>
    );
}

export default ProgressGate;
